import { removeTrailingSlash } from "@/utilities/strings";
import type { NavItem, NavLocation } from "../types";

export const samePath =
  (href: string) =>
  ({ pathname }: NavLocation) =>
    removeTrailingSlash(pathname) === removeTrailingSlash(href.split("?")[0]);

export const under =
  (prefix: string) =>
  ({ pathname }: NavLocation) => {
    const path = removeTrailingSlash(pathname);
    return path === prefix || path.startsWith(`${prefix}/`);
  };

// A parent lights when its own rule or any child does. A leaf lights on its
// own rule, or by default when the URL is the page it links to.
export const isNavItemActive = (
  item: NavItem,
  location: NavLocation,
): boolean => {
  if (item.children) {
    return (
      Boolean(item.activeWhen?.(location)) ||
      item.children.some((child) => isNavItemActive(child, location))
    );
  }

  if (item.activeWhen) return item.activeWhen(location);

  return item.target?.kind === "link" && samePath(item.target.href)(location);
};

export const ariaCurrent = (item: NavItem, location: NavLocation) => {
  if (!isNavItemActive(item, location)) return undefined;
  const { target } = item;
  const isPage =
    !item.children &&
    target?.kind === "link" &&
    samePath(target.href)(location);
  return isPage ? "page" : "true";
};
